import { Link } from 'react-router';
import { formatDate } from '@mys/contracts/format';
import { useEditRequests } from '../lib/portal.js';

/* ============================================================================
   /edit-requests — changes asked for, and what happened to them.
   ----------------------------------------------------------------------------
   The whole value of this screen is that a client can see we have their
   request without messaging to ask. Open ones are listed first for that
   reason: "is anyone looking at this?" is the question, not "what did I send
   in March".
   ========================================================================== */

export function EditRequestsPage() {
  const requests = useEditRequests();

  if (requests.isPending) return <p className="muted">Load ho raha hai…</p>;

  if (requests.error) {
    return (
      <p className="alert" role="alert">
        Abhi load nahi ho paya. Thodi der baad dobara kholiye.
      </p>
    );
  }

  const items = requests.data?.editRequests ?? [];
  const open = items.filter((item) => item.status === 'open');
  const done = items.filter((item) => item.status !== 'open');

  return (
    <>
      <div className="page-head">
        <h1 className="h1">Changes</h1>
        <Link className="btn btn--small" to="/edit-requests/new">
          Naya
        </Link>
      </div>

      {items.length === 0 ? (
        <section className="card stack">
          <p className="muted">
            Abhi tak koi change nahi manga. Site par kuch badalna ho — photo, number, timing — to
            yahin se bata dijiye.
          </p>
          <Link className="btn" to="/edit-requests/new">
            Change maangiye
          </Link>
        </section>
      ) : null}

      {open.length > 0 ? (
        <>
          <p className="kicker">Chalu hai ({open.length})</p>
          <ul className="list">
            {open.map((item) => (
              <li key={item.id} className="list__row list__row--static">
                <span>
                  {item.message}
                  <br />
                  <span className="muted small">{formatDate(item.createdAt)}</span>
                </span>
                <span className="pill pill--due">Pending</span>
              </li>
            ))}
          </ul>
        </>
      ) : null}

      {done.length > 0 ? (
        <>
          <p className="kicker">Ho gaya ({done.length})</p>
          <ul className="list">
            {done.map((item) => (
              <li key={item.id} className="list__row list__row--static">
                <span>
                  {item.message}
                  <br />
                  <span className="muted small">
                    {item.doneAt ? `${formatDate(item.doneAt)} ko poora hua` : 'Ho gaya'}
                  </span>
                </span>
                <span className="pill">Done</span>
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </>
  );
}
